var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'underscore.string', 'backbone', 'mixin', 'core', 'app-common/view/base', 'app-common/component/notification', 'app-common/component/loader', 'app-common/model/file', 'app-common/component/api-call', 'component/document-viewer', 'common/component/money-formatter', 'component/editing-toolbar', 'template/pagination.htm', 'common/location'], function($, _, _s, Backbone, mixin, core, BaseView, NotificationSupport, loader, FileModel, apiCall, DocumentViewer, moneyFormatter, EditingToolbarView, paginationTemplate, location) {
  var DocumentView, SplitFeatureFlags;
  SplitFeatureFlags = require('bk-web-app/features').SplitFeatureFlags;
  return DocumentView = (function(_super) {
    var getStatusHtml, statuses, statusesToShowTicketId, statusesToShowTimestamp;

    __extends(DocumentView, _super);

    function DocumentView() {
      DocumentView.__super__.constructor.apply(this, arguments);
    }

    DocumentView.prototype.events = {
      'click .pagination-item:not(.active)': 'goToPage',
      'click .pagination-prev:not(.disabled)': 'prevPage',
      'click .pagination-next:not(.disabled)': 'nextPage',
      'click .folder-tab-button': 'switchSelectedType'
    };

    DocumentView.prototype.types = [
      {
        title: 'receipts',
        type: 'RECEIPT'
      }, {
        title: 'statements',
        type: 'STATEMENT'
      }, {
        title: 'tax',
        type: 'TAX'
      }, {
        title: 'exports',
        type: 'EXPORTS'
      }, {
        title: 'other',
        type: 'NOT_STATEMENT'
      }
    ];

    DocumentView.prototype.toolbarActions = [
      {
        name: 'delete',
        icon: 'ss-trash ss-gizmo',
        withConfirmation: true,
        callback: function() {
          return this.toolbarActionRemove();
        },
        message: "Delete your selected items?"
      }, {
        name: 'download',
        icon: 'ss-download ss-gizmo',
        withConfirmation: true,
        callback: function() {
          return this.toolbarActionDownload();
        },
        message: "Download your selected items?"
      }
    ];

    DocumentView.prototype.selectedType = 'RECEIPT';

    DocumentView.prototype.selectedPage = 1;

    DocumentView.prototype.animationDuration = 700;

    statuses = [
      {
        name: 'Ready',
        icon: 'bl-icon-notification-bell',
        "class": 'status-ready',
        status: 'READY'
      }, {
        name: 'Sent',
        icon: 'bl-icon-post-message',
        "class": 'status-sent',
        status: 'SENT'
      }, {
        name: 'Received',
        icon: 'bl-icon-mail',
        "class": 'status-sent',
        status: 'RECEIVED'
      }, {
        name: 'Assigned',
        icon: 'bl-icon-person',
        "class": 'status-sent',
        status: 'ASSIGNED'
      }, {
        name: 'Re-sent',
        icon: 'bl-icon-post-message',
        "class": 'status-sent',
        status: 'REJECTED_BY_BK'
      }, {
        name: 'In Progress',
        icon: 'bl-icon-abacus',
        "class": 'status-in-process',
        status: 'IN_PROGRESS'
      }, {
        name: 'Processed by DP',
        icon: 'bl-icon-checkmark',
        "class": 'status-reconcile',
        status: 'PROCESSED_BY_DP'
      }, {
        name: 'Processed by BK',
        icon: 'bl-icon-checkmark',
        "class": 'status-complete',
        status: 'PROCESSED_BY_BK'
      }, {
        name: 'Rejected',
        icon: 'bl-icon-close',
        "class": 'status-rejected',
        status: 'REJECTED_BY_DP'
      }
    ];

    statusesToShowTicketId = ['RECEIVED', 'ASSIGNED', 'IN_PROGRESS', 'PROCESSED_BY_DP'];

    statusesToShowTimestamp = ['SENT', 'RECEIVED', 'ASSIGNED', 'IN_PROGRESS'];

    getStatusHtml = function(dpName, dpStatus, dpTicketId, dpSentTimestamp) {
      var bubbleSpan, containerDiv, formattedDate, iconSpan, showSentTimestamp, showTicketId, status, ticketSpan, timestampSpan, tooltipSpan;
      showTicketId = dpTicketId && statusesToShowTicketId.includes(dpStatus);
      showSentTimestamp = dpSentTimestamp && statusesToShowTimestamp.includes(dpStatus);
      status = _.find(statuses, function(s) {
        return s.status === ("" + dpStatus);
      });
      iconSpan = document.createElement('span');
      iconSpan.className = "status-icon " + status.icon + " " + status["class"];
      tooltipSpan = document.createElement('span');
      tooltipSpan.className = 'dp-status-tooltip';
      tooltipSpan.textContent = status.name;
      if (showTicketId || showSentTimestamp) {
        bubbleSpan = document.createElement('span');
        bubbleSpan.className = 'dp-status-tooltip-bubble';
        if (dpTicketId && showSentTimestamp) {
          bubbleSpan.classList.add('two-lines');
        }
        if (showTicketId) {
          ticketSpan = document.createElement('span');
          ticketSpan.textContent = "Ticket " + dpTicketId;
          bubbleSpan.appendChild(ticketSpan);
        }
        if (showSentTimestamp) {
          timestampSpan = document.createElement('span');
          formattedDate = new Date(dpSentTimestamp).toLocaleString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
          }).toLowerCase();
          timestampSpan.textContent = "Sent on " + formattedDate;
          bubbleSpan.appendChild(timestampSpan);
        }
        tooltipSpan.appendChild(bubbleSpan);
      }
      containerDiv = document.createElement('div');
      containerDiv.className = 'dp-status-container';
      containerDiv.appendChild(iconSpan);
      containerDiv.appendChild(tooltipSpan);
      return containerDiv.outerHTML;
    };

    DocumentView.prototype.initialize = function(options, params) {
      DocumentView.__super__.initialize.apply(this, arguments);
      return this.router = core.getRouter();
    };

    DocumentView.prototype.isClassifyWithLlmEnabled = function() {
      return core.isFeatureEnabled(SplitFeatureFlags.AUTO_DOCUMENT_CLASSIFICATION);
    };

    DocumentView.prototype.updateUrl = function(params, replace) {
      var url;
      if (params == null) {
        params = [];
      }
      if (replace == null) {
        replace = false;
      }
      return url = this.router.buildUrl(this.pageId, params);
    };

    DocumentView.prototype.loadData = function(replaceUrl, showLoader, paramsObject) {
      var action, params, promise,
        _this = this;
      if (replaceUrl == null) {
        replaceUrl = false;
      }
      if (showLoader == null) {
        showLoader = true;
      }
      if (paramsObject == null) {
        paramsObject = {};
      }
      if (showLoader) {
        loader.init();
      }
      this.refreshUrl(replaceUrl);
      params = $.param(paramsObject);
      action = !paramsObject.query ? 'find' : 'search';
      promise = apiCall('document', ("client/" + (core.getCurrentClientId()) + "/find/" + this.selectedType + "?") + params);
      promise.always(function() {
        if (showLoader) {
          return loader.hide();
        }
      });
      promise.done(function(data) {
        _this.data = data;
        return _this.refresh();
      });
      return promise;
    };

    DocumentView.prototype.refreshTable = function() {
      var amountColumn, checkboxColumn, closingBalanceColumn, columnCounter, dateColumn, dateCreationColumn, documentEntryColumn, documentTypeColumn, downloadColumn, dpStatusColumn, fileColumn, filenameColumn, formatDate, formatTimestamp, fullDateCreationColumn, generatedNameColumn, getLedgerName, ledgerCollection, ledgerColumn, matchedColumn, nameColumn, openingBalanceColumn, parseDateString, reclassifyColumn, rowCallback, truncateColumn, typesColumnsConfig, vendorColumn,
        _this = this;
      ledgerCollection = core.getCollection('ledgerAccounts');
      rowCallback = function(row, data) {
        if ($(row).hasClass('folder__document')) {
          return row;
        }
        return $(row).addClass('folder__document').data('id', data.id);
      };
      parseDateString = function(dateString) {
        var date, splitDateString;
        splitDateString = dateString.split('/');
        date = new Date();
        date.set({
          month: parseInt(splitDateString[0] - 1),
          day: parseInt(splitDateString[1]),
          year: parseInt(splitDateString[2]),
          hour: 0,
          minute: 0,
          second: 0
        });
        return date;
      };
      formatDate = function(date) {
        return date.toString('MMM') + ' ' + date.toString('dd');
      };
      formatTimestamp = function(timestamp) {
        if (timestamp) {
          return new Date(timestamp).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
          });
        } else {
          return null;
        }
      };
      truncateColumn = function(column) {
        if (column.length > 60) {
          return column.substring(0, 60) + "...";
        } else {
          return column;
        }
      };
      getLedgerName = function(ledgerId) {
        var ledger;
        ledger = ledgerCollection != null ? ledgerCollection.get(ledgerId) : void 0;
        return ledger != null ? ledger.get('name') : void 0;
      };
      /* Collection of columns
      */

      checkboxColumn = {
        sTitle: '<div class="fake-column-checkbox hide all-checkbox-wrapper"><input class="all-checkbox" type="checkbox"><label></label></div>',
        sClass: 'folder__document-input',
        mData: null,
        mRender: function() {
          return '<div class="fake-column-checkbox"><input class="row-checkbox" type="checkbox" /><label></label></div>';
        }
      };
      dateCreationColumn = {
        sTitle: 'Upload Date',
        sClass: 'folder__document-upload-date',
        mData: 'documentCreationDate',
        mRender: function(dateString) {
          var date;
          date = parseDateString(dateString);
          return "<span data-order='" + (date.getTime()) + "'>" + (formatDate(date)) + "</span>";
        }
      };
      dateColumn = {
        sTitle: 'Date',
        sClass: 'folder__document-date',
        mData: 'documentDate',
        mRender: function(dateString) {
          var date;
          date = parseDateString(dateString);
          return formatDate(date);
        }
      };
      vendorColumn = {
        sTitle: 'Vendor',
        sClass: 'folder__document-vendor',
        mData: null,
        mRender: function(a, type, data) {
          return data.vendor || '';
        }
      };
      filenameColumn = {
        sTitle: 'Filename',
        sClass: 'folder__document-filename',
        mData: null,
        mRender: function(a, type, data) {
          var decodedFilename, filename, rawFilename, _ref, _ref1;
          rawFilename = ((_ref = data.attributes) != null ? _ref.name : void 0) || ((_ref1 = data.file) != null ? _ref1.displayName : void 0) || '';
          try {
            decodedFilename = decodeURIComponent(rawFilename);
          } catch (e) {
            decodedFilename = rawFilename;
          }
          filename = truncateColumn(decodedFilename);
          return _s.escapeHTML(filename);
        }
      };
      generatedNameColumn = {
        sTitle: 'Generated Name',
        sClass: 'folder__document-generated-name',
        mData: null,
        mRender: function(a, type, data) {
          var classifiedDate, confidenceClass, confidencePercent, metadata, value, _ref, _ref1, _ref2, _ref3, _ref4;
          value = ((_ref = data.file) != null ? (_ref1 = _ref.metadata) != null ? _ref1.generatedFilename : void 0 : void 0) || 'Req on: ' + formatTimestamp((_ref2 = data.file) != null ? (_ref3 = _ref2.metadata) != null ? _ref3.requestedAt : void 0 : void 0);
          metadata = (_ref4 = data.file) != null ? _ref4.metadata : void 0;
          if ((metadata != null ? metadata.document_type : void 0) && (metadata != null ? metadata.confidence : void 0)) {
            confidencePercent = Math.round(metadata.confidence * 100);
            classifiedDate = formatTimestamp(metadata != null ? metadata.classifiedAt : void 0);
            confidenceClass = confidencePercent >= 95 ? 'high-confidence' : confidencePercent >= 85 ? 'medium-confidence' : 'low-confidence';
            return "<span class='generated-name-with-tooltip'>\n    " + (_s.escapeHTML(value)) + "\n    <span class='classification-info-icon'>&#9432;</span>\n    <span class='classification-tooltip-bubble'>\n        <span><strong>Type:</strong> " + (_s.escapeHTML(metadata.document_type)) + "</span>\n        <span class='" + confidenceClass + "'><strong>Confidence:</strong> " + confidencePercent + "%</span>\n        " + (metadata.reasoning ? "<span><strong>Reasoning:</strong> " + (_s.escapeHTML(metadata.reasoning)) + "</span>" : "") + "\n    </span>\n</span>";
          }
          return _s.escapeHTML(value);
        }
      };
      fullDateCreationColumn = {
        sTitle: 'Upload Date',
        sClass: 'folder__document-upload-date',
        mData: 'documentCreationDate',
        mRender: function(dateString) {
          var date;
          date = parseDateString(dateString);
          return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: '2-digit'
          });
        }
      };
      documentTypeColumn = {
        sTitle: 'Document Type',
        sClass: 'folder__document-filename',
        mData: null,
        mRender: function(data) {
          var documentType;
          documentType = (data != null ? data.documentType : void 0) && data.documentType.charAt(0).toUpperCase() + data.documentType.slice(1).toLowerCase() || '';
          return _s.escapeHTML(documentType);
        }
      };
      ledgerColumn = {
        sTitle: 'Ledger',
        sClass: 'folder__document-filename',
        mData: null,
        mRender: function(data) {
          var filename, _ref;
          filename = truncateColumn(((_ref = data.attributes) != null ? _ref.ledgerAccountId : void 0) && getLedgerName(data.attributes.ledgerAccountId) || '');
          return _s.escapeHTML(filename);
        }
      };
      dpStatusColumn = {
        sTitle: 'DP Status',
        sClass: 'folder__document-filename',
        mData: null,
        mRender: function(data) {
          var _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
          if (data.dataProcessingMetadata) {
            return getStatusHtml((_ref = data.dataProcessingMetadata) != null ? _ref.dataProcessor : void 0, (_ref1 = data.dataProcessingMetadata) != null ? _ref1.status : void 0, (_ref2 = data.dataProcessingMetadata) != null ? _ref2.ticketId : void 0, (_ref3 = data.dataProcessingMetadata) != null ? _ref3.sentToDpTimestamp : void 0);
          } else if (((_ref4 = data.file) != null ? (_ref5 = _ref4.metadata) != null ? _ref5.source : void 0 : void 0) === 'PLAID_OCR' && data.documentType === 'UNKNOWN' && ((_ref6 = data.file) != null ? (_ref7 = _ref6.displayName) != null ? _ref7.toUpperCase().startsWith('OCRF') : void 0 : void 0)) {
            return "<span class='dp-status-tooltip'>Manual DP only</span>";
          } else {
            return "";
          }
        }
      };
      nameColumn = {
        sTitle: 'Name',
        sClass: 'folder__document-name',
        mData: 'attributes',
        mRender: function(attributes) {
          return (attributes != null ? attributes.name : void 0) || '';
        }
      };
      fileColumn = {
        sTitle: 'Document',
        sClass: 'folder__document-image',
        mData: null,
        mRender: function(a, type, data) {
          return "<span class='document-image-tooltip' data-file-id='" + data.fileId + "'>                        <img data-id='" + data.id + "' src='" + location.apiRoot + (core.getConfig().apiPrefix) + "file.json/" + data.fileId + "/page/1/type/THUMBNAIL' alt='' />                        <span class='tooltip-content'>                            <img class='tooltip-image' alt='' />                        </span>                    </span>";
        }
      };
      downloadColumn = {
        sTitle: 'Download',
        sClass: 'folder__document-download',
        mData: null,
        mRender: function(a, type, data) {
          if (data.fileId) {
            return "<span data-document-id='" + data.id + "' data-id='" + data.fileId + "' class='download-file ss-download ss-gizmo'></span>";
          } else {
            return "";
          }
        }
      };
      matchedColumn = {
        sTitle: 'Matched',
        sClass: 'folder__document-matched',
        mData: 'id',
        mRender: function(id, type, data) {
          if (data.documentType === 'TRANSACTIONAL') {
            return "<span data-id='" + id + "' class='matched-yes'>Yes</span>";
          } else {
            return '<span class="matched-no">No</span>';
          }
        }
      };
      openingBalanceColumn = {
        sTitle: 'Opening Balance',
        sClass: 'folder__document-balance',
        mData: 'attributes',
        mRender: function(attributes) {
          return (attributes != null ? attributes.openingBalance : void 0) || '';
        }
      };
      closingBalanceColumn = {
        sTitle: 'Closing Balance',
        sClass: 'folder__document-balance',
        mData: 'attributes',
        mRender: function(attributes) {
          return (attributes != null ? attributes.closingBalance : void 0) || '';
        }
      };
      amountColumn = {
        sTitle: 'Amount',
        sClass: 'folder__document-amount',
        mData: null,
        mRender: function(a, type, data) {
          var amount, _ref, _ref1;
          amount = (_ref = data.dataEntries) != null ? (_ref1 = _ref[0]) != null ? _ref1.amount : void 0 : void 0;
          if (amount) {
            return moneyFormatter.formatNumber(amount);
          } else {
            return '';
          }
        }
      };
      documentEntryColumn = {
        sTitle: 'Edit',
        sClass: 'folder__document-de',
        mData: 'id',
        mRender: function(id) {
          return "<span data-id='" + id + "' class='open-document-entry ss-file ss-gizmo'></span>";
        }
      };
      reclassifyColumn = {
        sTitle: 'Classified',
        sClass: 'folder__document-reclassify',
        mData: null,
        mRender: function(a, type, data) {
          var classifiedDate, createdAt, fiveMinutesAgo, generatedFilename, isOlderThanFiveMinutes, isProcessing, metadata, _ref;
          if (!data.fileId) {
            return "";
          }
          metadata = (_ref = data.file) != null ? _ref.metadata : void 0;
          generatedFilename = metadata != null ? metadata.generatedFilename : void 0;
          createdAt = data.documentCreationDateUTC;
          fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
          isOlderThanFiveMinutes = createdAt && new Date(createdAt).getTime() < fiveMinutesAgo;
          isProcessing = createdAt && !generatedFilename && !isOlderThanFiveMinutes;
          if (isProcessing) {
            return "<span class='reclassify-file ss-refresh ss-gizmo disabled spinning' title='Processing...'></span>";
          }
          if (!(generatedFilename || isOlderThanFiveMinutes)) {
            return "";
          }
          classifiedDate = formatTimestamp(metadata != null ? metadata.classifiedAt : void 0);
          if (classifiedDate) {
            return "<div class='classification-info'>                            <div class='classified-date'>" + classifiedDate + "</div>                            <span data-file-id='" + data.fileId + "' class='reclassify-file ss-refresh ss-gizmo' title='Reclassify document'></span>                        </div>";
          } else {
            return "<span data-file-id='" + data.fileId + "' class='reclassify-file ss-refresh ss-gizmo' title='Reclassify document'></span>";
          }
        }
      };
      /* Combine columns based on type here
      */

      if (this.isClassifyWithLlmEnabled()) {
        typesColumnsConfig = {
          'RECEIPT': [checkboxColumn, vendorColumn, dateColumn, fileColumn, amountColumn, matchedColumn],
          'STATEMENT': [checkboxColumn, nameColumn, openingBalanceColumn, closingBalanceColumn, dateColumn, downloadColumn],
          'TAX': [checkboxColumn, dateColumn, nameColumn, downloadColumn],
          'EXPORTS': [checkboxColumn, dateColumn, nameColumn, downloadColumn],
          'NOT_STATEMENT': [checkboxColumn, dateColumn, nameColumn, downloadColumn],
          'UNKNOWN': [checkboxColumn, dateCreationColumn, filenameColumn, generatedNameColumn, fileColumn, reclassifyColumn, downloadColumn],
          'ALL': [checkboxColumn, fullDateCreationColumn, filenameColumn, generatedNameColumn, documentTypeColumn, ledgerColumn, dpStatusColumn, fileColumn, reclassifyColumn, downloadColumn]
        };
      } else {
        typesColumnsConfig = {
          'RECEIPT': [checkboxColumn, vendorColumn, dateColumn, fileColumn, amountColumn, matchedColumn],
          'STATEMENT': [checkboxColumn, nameColumn, openingBalanceColumn, closingBalanceColumn, dateColumn, downloadColumn],
          'TAX': [checkboxColumn, dateColumn, nameColumn, downloadColumn],
          'EXPORTS': [checkboxColumn, dateColumn, nameColumn, downloadColumn],
          'NOT_STATEMENT': [checkboxColumn, dateColumn, nameColumn, downloadColumn],
          'UNKNOWN': [checkboxColumn, dateCreationColumn, filenameColumn, fileColumn, downloadColumn],
          'ALL': [checkboxColumn, fullDateCreationColumn, filenameColumn, documentTypeColumn, ledgerColumn, dpStatusColumn, fileColumn, downloadColumn]
        };
      }
      if (core.isCurrentClientBookkeeper()) {
        _.each(typesColumnsConfig, function(columns, type) {
          return typesColumnsConfig[type].push(documentEntryColumn);
        });
      }
      columnCounter = 0;
      this.$el.find('.dataTables_wrapper').remove();
      this.$el.find('.folder-wrapper').append('<table class="folder"></table>');
      this.datatable = this.$el.find('table.folder').dataTable({
        aoColumnDefs: typesColumnsConfig[this.selectedType].map(function(column) {
          column.aTargets = [columnCounter++];
          return column;
        }),
        bInfo: false,
        bLengthChange: false,
        bFilter: false,
        bPaginate: false,
        bAutoWidth: false,
        bSort: true,
        fnRowCallback: rowCallback,
        oLanguage: {
          sEmptyTable: "There are no documents in this folder yet."
        }
      });
      $(this.datatable).on('click', '.folder__document-image img', function() {
        return new DocumentViewer({
          document: $(this).data('id')
        });
      });
      $(this.datatable).on('click', '.download-file', function(e) {
        var documentId, id;
        id = $(e.currentTarget).data('id');
        documentId = $(e.currentTarget).data('document-id');
        if (_this.selectedType === 'STATEMENT' && core.isCurrentClientBookkeeper()) {
          return new FileModel({
            id: id
          }).downloadAsStatement(documentId);
        } else {
          return new FileModel({
            id: id
          }).download();
        }
      });
      $(this.datatable).on('click', '.reclassify-file', function(e) {
        var $icon, clientId, fileId, promise;
        if (!_this.isClassifyWithLlmEnabled()) {
          return;
        }
        fileId = $(e.currentTarget).data('file-id');
        $icon = $(e.currentTarget);
        $icon.addClass('spinning');
        loader.init();
        clientId = core.getCurrentClientId();
        promise = $.ajax({
          url: "" + location.v2BookkeepingApiRoot + "/client/" + clientId + "/file/" + fileId + "/reclassify",
          type: 'POST',
          xhrFields: {
            withCredentials: true
          }
        });
        promise.always(function() {
          loader.hide();
          return $icon.removeClass('spinning');
        });
        promise.done(function() {
          _this.showNotification('success', 'Document reclassified successfully');
          return _this.loadData(false, false);
        });
        return promise.fail(function(error) {
          var errorMessage, _ref;
          errorMessage = (error != null ? (_ref = error.responseJSON) != null ? _ref.message : void 0 : void 0) || 'Failed to reclassify document';
          return _this.showNotification('error', errorMessage);
        });
      });
      $(this.datatable).on('click', '.open-document-entry', function(e) {
        var queryVals;
        queryVals = core.isFeatureEnabled(SplitFeatureFlags.AUTO_DOCUMENT_CLASSIFICATION_AUTOFILL) ? {
          prefill: 'true'
        } : {};
        return _this.router.loadPage('document-entry', [$(e.currentTarget).data('id')], {
          queryVals: queryVals
        });
      });
      $(this.datatable).on('change', '.all-checkbox', function(e) {
        return _this.toggleRowsSelection($(e.currentTarget).prop('checked'));
      });
      $(this.datatable).on('mouseenter', '.document-image-tooltip', function(e) {
        var $tooltip, $tooltipImage, fileId, imageSrc;
        $tooltip = $(e.currentTarget);
        $tooltipImage = $tooltip.find('.tooltip-image');
        if (!$tooltipImage.attr('src')) {
          fileId = $tooltip.data('file-id');
          imageSrc = "" + location.apiRoot + (core.getConfig().apiPrefix) + "file.json/" + fileId + "/page/1/type/REPORT";
          return $tooltipImage.attr('src', imageSrc);
        }
      });
      return $(this.datatable).on('change', '.row-checkbox', function() {
        var checkedRows, isAllChecked, totalRows;
        totalRows = _this.$el.find('.row-checkbox').length;
        checkedRows = _this.$el.find('.row-checkbox:checked').length;
        isAllChecked = totalRows === checkedRows;
        _this.$el.find('.all-checkbox').prop('checked', isAllChecked);
        if (checkedRows > 0) {
          return _this.showEditing();
        } else {
          return _this.hideEditing();
        }
      });
    };

    DocumentView.prototype.toggleRowsSelection = function(enable) {
      var _this = this;
      $(this.datatable).find('.row-checkbox').each(function(i, checkbox) {
        if (enable) {
          return $(checkbox).prop('checked', true);
        } else {
          return $(checkbox).prop('checked', false);
        }
      });
      if (enable) {
        return this.showEditing();
      } else {
        return this.hideEditing();
      }
    };

    DocumentView.prototype.resetSelection = function() {
      return $(this.datatable).find('.all-checkbox,.row-checkbox').prop('checked', false);
    };

    DocumentView.prototype.showEditing = function() {
      if (!this.editingToolbar) {
        this.editingToolbar = new EditingToolbarView({
          actions: this.toolbarActions,
          context: this
        });
        return this.$el.append(this.editingToolbar.$el);
      }
    };

    DocumentView.prototype.hideEditing = function() {
      var _ref;
      if ((_ref = this.editingToolbar) != null) {
        _ref.remove();
      }
      return this.editingToolbar = null;
    };

    DocumentView.prototype.toolbarActionRemove = function() {
      var checkedRows, ids, promise,
        _this = this;
      checkedRows = this.$el.find('.row-checkbox:checked');
      ids = checkedRows.map(function() {
        return $(this).closest('.folder__document').data('id');
      }).get().join();
      loader.init();
      promise = apiCall('document', 'list?ids=' + ids, 'DELETE');
      promise.always(function() {
        return loader.hide();
      });
      return promise.done(function() {
        _this.hideEditing();
        return _this.loadData();
      });
    };

    DocumentView.prototype.toolbarActionDownload = function() {
      var checkedRows, ids;
      checkedRows = this.$el.find('.row-checkbox:checked');
      ids = checkedRows.map(function() {
        return $(this).closest('.folder__document').data('id');
      }).get().join();
      window.location.href = location.apiRoot + new FileModel().pathRoot + '/download/list?ids=' + ids;
      return this.hideEditing();
    };

    DocumentView.prototype.refresh = function() {
      var _this = this;
      this.hideEditing();
      this.datatable.fnClearTable();
      if (this.data.results.length === 0) {
        $(this.datatable).find('.all-checkbox-wrapper').hide();
      } else {
        $(this.datatable).find('.all-checkbox-wrapper').show();
      }
      _.each(this.data.results, function(document) {
        return _this.datatable.fnAddData(document);
      });
      this.updatePagination();
      this.resetSelection();
      this.setSelectedTab();
      if (this.hasProcessingFiles()) {
        return this.startPolling();
      } else {
        return this.stopPolling();
      }
    };

    DocumentView.prototype.hasProcessingFiles = function() {
      var fiveMinutesAgo, _ref;
      if (!((_ref = this.data) != null ? _ref.results : void 0)) {
        return false;
      }
      fiveMinutesAgo = Date.now() - (5 * 60 * 1000);
      return this.data.results.some(function(doc) {
        var createdAt, generatedFilename, _ref1, _ref2;
        createdAt = doc.documentCreationDateUTC;
        generatedFilename = (_ref1 = doc.file) != null ? (_ref2 = _ref1.metadata) != null ? _ref2.generatedFilename : void 0 : void 0;
        return createdAt && !generatedFilename && new Date(createdAt).getTime() >= fiveMinutesAgo;
      });
    };

    DocumentView.prototype.startPolling = function() {
      var _this = this;
      if (this.pollingInterval) {
        return;
      }
      return this.pollingInterval = setInterval(function() {
        return _this.loadData(false, false);
      }, 30000);
    };

    DocumentView.prototype.stopPolling = function() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        return this.pollingInterval = null;
      }
    };

    DocumentView.prototype.remove = function() {
      this.stopPolling();
      return DocumentView.__super__.remove.apply(this, arguments);
    };

    DocumentView.prototype.updatePagination = function() {
      var template, totalPages;
      totalPages = Math.ceil(this.data.totalResults / this.data.resultsPerPage);
      if (totalPages < 2) {
        this.$el.find('.pagination').remove();
        return;
      }
      template = _.template(paginationTemplate, {
        totalPages: totalPages,
        currentPage: this.selectedPage
      });
      if (this.$el.find('.pagination').length === 0) {
        return this.$el.find('.folder').after(template);
      } else {
        return this.$el.find('.pagination').replaceWith(template);
      }
    };

    DocumentView.prototype.goToPage = function(e) {
      this.selectedPage = parseInt($(e.currentTarget).text());
      return this.loadData();
    };

    DocumentView.prototype.prevPage = function() {
      this.selectedPage--;
      return this.loadData();
    };

    DocumentView.prototype.nextPage = function() {
      this.selectedPage++;
      return this.loadData();
    };

    DocumentView.prototype.setSelectedTab = function() {
      if (this.selectedType === 'UNKNOWN') {
        $('.all-documents-tab').removeClass('active');
        return $('.unsorted-documents-tab').addClass('active');
      } else if (this.selectedType === 'ALL') {
        $('.all-documents-tab').addClass('active');
        return $('.unsorted-documents-tab').removeClass('active');
      }
    };

    DocumentView.prototype.switchSelectedType = function(e) {
      var tab;
      tab = $(e.currentTarget);
      this.selectedType = tab.data('type');
      return this.loadData();
    };

    return DocumentView;

  })(mixin.of(BaseView, NotificationSupport));
});
